import { Controller, useFormContext } from "react-hook-form";
import { FormHelperText, Box, Typography } from "@mui/material";
import { StyledSlider, StyledLabel } from "./StyleInputs";
import { formatBigNumber, parseNumber } from "utils/formUtils";

const formatSliderLabel = (label, value) => {
  if (!label) return `Value: ${value}`;
  return label.replace("{value}", formatBigNumber(value));
};

const SliderField = ({ field }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const errorMessage = errors[field.id]?.message;

  const min =
    field?.validation?.min !== undefined
      ? parseNumber(field?.validation?.min)
      : 0;
  const max =
    field?.validation?.max !== undefined
      ? parseNumber(field?.validation?.max)
      : 100;

  return (
    <Box sx={{ mb: 3 }}>
      <StyledLabel required={field.required}>{field.label}</StyledLabel>
      <Controller
        name={field.id}
        control={control}
        defaultValue={min}
        rules={{
          required: field.required ? `${field.label} is required` : false,
          validate: (value) => {
            if (
              field.validation?.min !== undefined &&
              value < field.validation.min
            ) {
              return `Value must be at least ${field.validation.min}`;
            }
            if (
              field.validation?.max !== undefined &&
              value > field.validation.max
            ) {
              return `Value must be at most ${field.validation.max}`;
            }
            return true;
          },
        }}
        render={({ field: { onChange, value = min } }) => (
          <>
            <Box sx={{ px: 1 }}>
              <StyledSlider
                value={value}
                onChange={(_, newValue) => onChange(newValue)}
                min={min}
                max={max}
                valueLabelDisplay="auto"
                valueLabelFormat={(value) =>
                  formatSliderLabel(field.sliderLabel, value)
                }
                marks={Boolean(field?.stepCount)}
                {...(field?.stepCount && {
                  step: +field?.stepCount,
                })}
              />
            </Box>
            <Typography
              variant="body2"
              align="center"
              sx={{ mt: 1, fontWeight: 600 }}
            >
              {formatSliderLabel(field.sliderLabel, value)}
            </Typography>
            {errorMessage && (
              <FormHelperText error>{errorMessage}</FormHelperText>
            )}
          </>
        )}
      />
    </Box>
  );
};

export default SliderField;
